import { render, staticRenderFns } from "./TireConfirmInfo.vue?vue&type=template&id=18122247&scoped=true"
import script from "./TireConfirmInfo.vue?vue&type=script&lang=ts"
export * from "./TireConfirmInfo.vue?vue&type=script&lang=ts"
import style0 from "./TireConfirmInfo.vue?vue&type=style&index=0&id=18122247&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18122247",
  null
  
)

export default component.exports